export default __webpack_public_path__ + "static/media/logo-telemedicine-1.fbfa452a.svg";